import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { BrandService } from '../brand.service';

@Component({
  selector: 'app-create-brand',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule
  ],
  templateUrl: './create-brand.component.html'
})
export class CreateBrandComponent implements OnInit {

  @Input() id!: number | null;
  form!: FormGroup;
  @Output() formSubmit = new EventEmitter<void>();
  @Output() modalClosed = new EventEmitter<void>();

  constructor(private fb: FormBuilder, private brandService: BrandService){

  }

  ngOnDestroy(): void {
    this.modalClosed.emit();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      description: ['', Validators.required],
      active: [true]
    });

    if(this.id){
      this.getBrandData();
    }
  }

  getBrandData(){
    this.brandService.getById(this.id as number).subscribe({
      next: (data) => {
        this.form.patchValue(data.data);
      }
    })
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  onSubmit(){
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
      return;
    }
    if(this.id)
      {
        this.brandService.update(this.id, this.form.value).subscribe({
          next: (data) => 
          {
              this.formSubmit.emit();
          },
          error: (error) => 
          {
            console.log(error);
          }
        })
      }else{
        this.brandService.create(this.form.value).subscribe({
          next: (data) => 
          {
            this.formSubmit.emit();
          },
          error: (error) => 
          {
            console.log(error);
          }
        })
      }
  }

}
